// extracted by mini-css-extract-plugin
module.exports = {"root":"AvailableBalance_root__w0V7T"};